import React, { Component } from "react"
import Layout from "../../components/layout"
import SEO from "../../components/seo"
import AOS from "aos"
import 'aos/dist/aos.css';
import NewsStrip from "../../components/news-strip"
import { Link } from "gatsby";
import imgPassenger from '../../images/news/tetleys-coaches-acquired-by-first.jpg';

class NewsPage extends Component {

  componentDidMount() {
    AOS.init();
    window.addEventListener('load', AOS.refresh);
    // @NOTE: Hack to force AOS to work :(
    window.setTimeout(AOS.refresh, 1000);
  }

  componentDidUpdate() {
    AOS.refresh();
  }

  render() {
    return (
      <Layout>
        <SEO title="Tetley's Coaches acquired by FirstGroup" description="Tetley's Coaches acquired by FirstGroup" />
        <div className="block-services inner-body-bg">
          <div className="body gutter page-content-parent page-article" style={{ background: 'white' }}>
            <div>
              <h1 className="page-content-heading">Tetley's Coaches acquired by FirstGroup</h1>
              <p className="news-article-date">August 2025</p>
            </div>

            <img src={imgPassenger} alt="" />

            <div className="news-article-body">
              <p><strong>A New Chapter – Same Trusted Service</strong></p>
              <p>We are proud to announce that <strong>Tetley’s Coaches has joined the First Bus family</strong>, following our acquisition by FirstGroup – one of the UK’s leading and most trusted public transport operators.</p>
              <p>This is a significant milestone in our 75+ year journey, and one we’ve entered into with great confidence and excitement. Most importantly, <strong>we want to reassure all of our valued customers, partners, and passengers that it’s absolutely business as usual.</strong></p>
              <p style={{ fontWeight: 'bold' }}>
                ✅ All bookings remain unchanged<br />
                ✅ Our team is staying the same<br />
                ✅ Our high standards of service and safety continue<br />
                ✅ We’re still Tetley’s – just with more support behind us
              </p>
              <p>We’ll still be operating from our <strong>Hunslet depot</strong>, and you’ll continue to see our familiar coaches out on the roads across West Yorkshire and beyond. With the backing of First Bus, we now have access to even more resources and support – helping us grow and improve, while staying true to the values that have earned your trust for over seven decades.</p>
              <p><strong>Our Managing Director, Ian Tetley, remains in place</strong> and will continue to help guide the business through this exciting new chapter. We’re also proud to continue our role in the wider coach industry, with Ian remaining Chair of the Confederation of Passenger Transport (CPT) Yorkshire region.</p>
              <p>Here’s what Ian had to say:</p>
              <p><em>“Joining First Bus is a positive step forward for Tetley’s. It gives us the strength of a national transport group behind us while keeping everything that makes Tetley’s special firmly in place – our people, our values, and our commitment to excellent service.”</em></p>
              <p>We’re grateful to all of you – schools, universities, businesses, travel agents, families, and individuals – who continue to choose Tetley’s Coaches. Thanks to your continued support, we’re growing stronger than ever.</p>
              <p>So whether it’s your daily school run, a sports team booking, a wedding, a day trip, or a cross-country tour, you can <strong>count on the same Tetley’s service, delivered by the same team you know and trust.</strong></p>
              <p>If you have any questions, don’t hesitate to reach out. We’re here – just as we’ve always been.</p>
              <p><strong>Thank you for being part of our journey.</strong></p>
              <p>Here’s to the road ahead.</p>
              <p><em>The Tetley’s Coaches Team</em></p>
            </div>
          </div>
        </div>

        <NewsStrip />

      </Layout>
    );
  }
}

export default NewsPage
